module.exports = __webpack_public_path__ + "img/3.8859b31b.png";